module.exports = __webpack_public_path__ + "img/downUp.e5876b5d.png";